// 前端通用格式化工具

// 金额格式化(人民币, 千分位)
export const fmtMoney = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '-';
  return '¥' + n.toLocaleString('zh-CN', { maximumFractionDigits: 2 });
};

// 数字格式化(千分位, 保留小数)
export const fmtNum = (v, digits = 2) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '-';
  return n.toLocaleString('zh-CN', { maximumFractionDigits: digits });
};

// 涨红跌绿(国内金融惯例): 盈利红色, 亏损绿色, 零灰色
export const profitClass = (v) => {
  const n = Number(v) || 0;
  if (n > 0) return 'text-[#cf222e]';
  if (n < 0) return 'text-[#1a7f37]';
  return 'text-[#656d76]';
};

// 带符号金额(盈喜亏)
export const fmtProfit = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return fmtMoney(0);
  return (n > 0 ? '+' : '') + fmtMoney(n);
};

// 时间格式化
export const fmtTime = (t) => {
  if (!t) return '-';
  const d = new Date(t);
  if (Number.isNaN(d.getTime())) return '-';
  const pad = (x) => String(x).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// 相对时间(几分钟前/几小时前)
export const fmtAgo = (t) => {
  if (!t) return '-';
  const ms = Date.now() - new Date(t).getTime();
  if (!Number.isFinite(ms)) return '-';
  if (ms < 0) return '刚刚';
  const min = Math.floor(ms / 60000);
  if (min < 1) return '刚刚';
  if (min < 60) return `${min} 分钟前`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour} 小时前`;
  return `${Math.floor(hour / 24)} 天前`;
};

// 指令类型中文名
export const commandTypeName = (t) => {
  const map = {
    CLOSE_ALL: '全部平仓',
    PAUSE: '暂停开新单',
    RESUME: '恢复运行',
    OPEN_BUY: '云端开多',
    OPEN_SELL: '云端开空',
    CLOSE: '按信号平仓'
  };
  return map[t] || t;
};

// 指令状态中文名 + 配色
export const commandStatusMeta = (s) => {
  const map = {
    pending: { name: '排队中', cls: 'bg-[#fff8c5] text-[#9a6700]' },
    picked: { name: '已拉取', cls: 'bg-[#ddf4ff] text-[#0969da]' },
    executed: { name: '已执行', cls: 'bg-[#dafbe1] text-[#1a7f37]' },
    failed: { name: '执行失败', cls: 'bg-[#ffebe9] text-[#cf222e]' },
    expired: { name: '已过期', cls: 'bg-[#f6f8fa] text-[#57606a]' },
    cancelled: { name: '已取消', cls: 'bg-[#f6f8fa] text-[#57606a]' }
  };
  return map[s] || { name: s, cls: 'bg-[#f6f8fa] text-[#57606a]' };
};
